/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"

import Link from "./link"
import Img from "gatsby-image/withIEPolyfill"
import { ab } from "../theme"

const ContentPageTwoColumn = ({
  image,
  imageAlt,
  heading,
  children,
  link,
  linkText,
  linkTarget,
  mode,
  reverse,
  currentLanguage,
  seoLinks,
}) => (
  <div
    sx={{
      variant: "spacingContainer",
    }}
  >
    <div
      sx={{
        display: "flex",
        flexDirection: ab({ _: "column", md: reverse ? "row-reverse" : "row" }),
      }}
    >
      <div
        sx={{
          flex: 1,
        }}
      >
        <Img
          fluid={{
            ...image,
            sizes: "(min-width: 824px) 616px, 100vw",
          }}
          alt={imageAlt}
          sx={{ width: "100%", marginBottom: ab({ _: 3, md: 0 }) }}
        />
      </div>
      <div
        sx={{
          flex: 1,
          py: 2,
          paddingLeft: ab({ _: 0, md: reverse ? 0 : 5 }),
          paddingRight: ab({ _: 0, md: reverse ? 5 : 0 }),
        }}
      >
        <h2
          sx={{
            p: 0,
            m: 0,
          }}
        >
          {heading}
        </h2>
        {children}
        {linkText && (
          <div
            sx={{
              paddingTop: 4,
            }}
          >
            <Link
              to={link}
              target={linkTarget}
              language={currentLanguage}
              seoLinks={seoLinks}
              sx={{
                variant: "styles.ghostButton",
                border: `solid 1px`,
                color: mode ? `modes.${mode}.primary` : "primary",
                px: 4,
                py: 2,
                "&:hover": {
                  bg: mode ? `modes.${mode}.primary` : "primary",
                  color: "#fff",
                },
              }}
            >
              {linkText}
            </Link>
          </div>
        )}
      </div>
    </div>
  </div>
)

ContentPageTwoColumn.propTypes = {
  image: PropTypes.object.isRequired,
  imageAlt: PropTypes.string,
  heading: PropTypes.string.isRequired,
  children: PropTypes.node,
  link: PropTypes.string,
  linkText: PropTypes.string,
  linkTarget: PropTypes.string,
  mode: PropTypes.oneOf(["", "pharma", "food", "environment"]),
  reverse: PropTypes.bool,
  language: PropTypes.oneOf(["", "de", "en"]),
  seoLinks: PropTypes.object,
}

ContentPageTwoColumn.defaultProps = {
  mode: "",
  reverse: false,
  seoLinks: {},
}

export default ContentPageTwoColumn
